import React, { useEffect, useState } from 'react';
import userprofileImage from '../../assets/images/useruploadImg.png';
import ReactFlagsSelect from "react-flags-select";
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { CountryFile } from './country';
import { useUpdateProfile, useProfileDetails, useUserSendMail, useUserVerifyMail } from './api/profileapi';
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../Loader/buttonLoad';
import { queryClient } from '../../config';
import { Timer } from '../../hook/expireTime';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../hook/usetoast'
import { useGetAirDropTimer } from '../home/api/api';
import { Check } from 'lucide-react';
import { copyToClipboard } from '../../lib/copytoClipboard';

const EMAILID_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const schema = yup.object().shape({
    username: yup.string()
        .matches(/^[a-zA-Z\s]*$/, "Username cannot contain numbers")
        .min(3, 'Name must be at least 3 characters')
        .max(30, 'Name must be at most 30 characters')
        .required('Name is Required'),
    email: yup.string()
        .matches(EMAILID_REGEX, "Invalid Email")
        .max(140, 'Email must be at most 140 characters')
        .required('Email is Required'),
    mobile: yup.string()
        .max(15, 'Mobile Number is Invalid')
        .required('Mobile Number is Required'),
    country: yup.string().required('Select Country'),
    pincode: yup.string().required("Pincode is required"),
    profileImage: yup.mixed()
        .nullable()
        .test("required", "Profile Image required", (file) => file ? Boolean(file) : true),
})


const ProfileDetails = () => {
    const [selfie, setSelfie] = useState();
    const [checkCover, setCheckCover] = useState(false)
    const [waitingTime, setWaitingTime] = useState(false)
    const [enableOTP, setEnableOTP] = useState(false)

    const [mailOTP, setMailOTP] = useState("");
    const [resendOTP, setResendOTP] = useState(false);
    const [countryName, setCountryName] = useState("")

    const { isloadingconnect, setIsloadingconnect, setUserDetails } = useModalContext()


    const getyear = new Date().getFullYear();
    const [dialCode, setDialCode] = useState('+91');
    const [countryCode, setCountryCode] = useState('');

    const toast = useToast()
    const navigate = useNavigate()

    const updateProfiledata = useUpdateProfile();
    const userData = useGetAirDropTimer()

    useEffect(() => {
        getProfile()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionStorage.getItem('user_JWT')])

    const getProfile = async () => {
        const res = await userData.mutateAsync()
        setUserDetails(res)
        if (!res?.data?.isEmailVerified) {
            toast.error("Kindly verify your email to proceed with further actions")
        }
    }
    const { data: userProfile, isLoading } = useProfileDetails()

    const userSendMail = useUserSendMail()
    const verfiyMail = useUserVerifyMail()
    const [verifiedMail, setVerifiedMail] = useState(false)

    const { control, handleSubmit, formState: { errors, isDirty, isValid }, reset, setValue, setError, clearErrors, getValues } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            username: "",
            email: "",
            mobile: "",
            country: "India",
            profileImage: "",
            otp: "",
            pincode: ""
        }
    });
    let checkEmail = getValues("email")


    useEffect(() => {
        let interval = setTimeout(() => {
            setWaitingTime(false);
            setEnableOTP(false)
            setMailOTP('')
        }, 120000);

        return () => {
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [waitingTime])

    const [selected, setSelected] = useState("");

    useEffect(() => {
        if (countryCode) {

            setValue("mobile", "")
            setError("mobile", { message: "Mobile Number is Required" })
            setValue("country", countryCode?.code)
            setSelected(countryCode.code)
            setDialCode(countryCode?.dial_code);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps      
    }, [countryCode])

    useEffect(() => {
        reset(userProfile)
        setSelfie(userProfile?.profileImage)
        const countryCodeFromProfile = userProfile?.country || "IN";
        setSelected(countryCodeFromProfile);
        setValue("country", countryCodeFromProfile);
        setVerifiedMail(userProfile?.isEmailVerified)
        if (userProfile?.dial_code) {

            setDialCode(userProfile?.dial_code)
        } else {
            setDialCode('+91')
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfile, reset])


    const checkRefChar = (e) => {
        if (e.target.value.length === 0 && e.key === ' ') {
            e.preventDefault();
        }
    };

    const onSubmit = async (data) => {

        try {

            setIsloadingconnect(true)
            const formData = new FormData()
            formData.append("name", data.username)
            formData.append("email", data.email)
            formData.append("mobile", data.mobile)
            formData.append("country", data.country)
            formData.append("profileimg", data.profileImage)
            formData.append("dial_code", dialCode)
            formData.append("country_code", countryName)
            formData.append("pincode", data.pincode)
            let res = await updateProfiledata.mutateAsync(formData)
            if (res) {
                queryClient.invalidateQueries('get-profile')
                setIsloadingconnect(false)
                setCheckCover(false)
            }
        } catch (error) {
            setIsloadingconnect(false)

        } finally {
            setIsloadingconnect(false)
        }
    }

    const sendEmail = async () => {
        try {

            setIsloadingconnect(true)
            const emailvalidation = !!errors.email


            if (!emailvalidation) {
                let emailss = getValues("email")

                const res = await userSendMail.mutateAsync({ email: emailss })
                if (res?.status) {
                    setResendOTP(true)
                    setEnableOTP(true)
                    setWaitingTime(true)
                    setIsloadingconnect(false)
                }
            }
        } catch (error) {

            setIsloadingconnect(false)
            setEnableOTP(false)

        } finally {
            setIsloadingconnect(false)
        }
    }

    const readFileAsync = (file) => {

        return new Promise(
            (resolve, reject) => {
                if (!file) return
                const reader1 = new FileReader()
                reader1.onload = () => {
                    resolve(reader1.result)
                }
                reader1.onerror = reject
                reader1.readAsDataURL(
                    file
                )
            }
        )
    }

    const SelfieImg = (event) => {
        let img = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const imgCheck = new Image();
            imgCheck.src = event.target.result;
            imgCheck.onload = async () => {
                if (imgCheck.width <= 6000 && imgCheck.height <= 6000) {

                    if (img.size < 2 * 1024 * 1024) {
                        const newImage1 = await readFileAsync(img)
                        setSelfie(newImage1);

                        setValue("profileImage", img)
                        setCheckCover(true)
                    } else {
                        toast.error('Image Size Must be Less than 2MB.')
                        setCheckCover(false)
                    }
                } else {
                    toast.error('Image Dimensions should be 6000 x 6000 Pixels.')
                    setCheckCover(false)
                }
            };

            imgCheck.onerror = (error) => {

            };
        }
        reader.onerror = (error) => {

        };
        reader.readAsDataURL(img);
    }

    const verifyMailOTP = async (e) => {


        clearErrors("otp")
        if (!mailOTP) {
            return setError("otp", { message: "OTP is required" })
        } else if (mailOTP.length !== 6) {
            return setError("otp", { message: "Invalid OTP" })
        }


        let obj = {
            "email_OTP": mailOTP
        }
        setIsloadingconnect(true)
        let res = await verfiyMail.mutateAsync(obj)
        if (res?.status) {
            setEnableOTP(false)
            setVerifiedMail(true)
            setMailOTP('')
            navigate('/dashboard')
            setIsloadingconnect(false)

        } else {
            toast.error(res.message);
            setIsloadingconnect(false)
            setMailOTP('')
        }
    }

    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setMailOTP(value);
        clearErrors("otp");
    };

    const handleKeyDown = (e) => {

        const regex = /^\d{0,6}$/;

        const value = e.target.value + e.key;

        if (!regex.test(value)) {
            e.preventDefault();
        }
    };

    let buttonContent;

    if (waitingTime) {
        buttonContent = (
            <span className="timerbx">
                <Timer />
            </span>
        );
    } else if (resendOTP) {
        buttonContent = (
            <button type='button' className='btn btn-primary mw-auto px-2 fs-12' onClick={() => sendEmail()}>
                Resend OTP <i className="fas fa-angle-right pl-2"></i>
            </button>
        );
    } else {
        buttonContent = (
            <button type='button' className='btn btn-primary mw-auto px-2 fs-12' onClick={() => sendEmail()}>
                Send OTP <i className="fas fa-angle-right pl-2"></i>
            </button>
        );
    }


    let content;

    if (verifiedMail === true) {
        content = (
            <span className='text-success fs-18 successTick'>
                <i className="bi bi-check-circle-fill"></i>
            </span>
        );
    } else if (userProfile?.username && userProfile?.email === checkEmail) {
        content = (
            <span className='verifyLinkbtn'>
                {buttonContent}
            </span>
        );
    } else {
        content = null;
    }

    const [uniqueId, setUniqueId] = useState(false)
    let copy;

    if (userProfile?.refferCode) {
        if (uniqueId === userProfile?.refferCode) {
            copy = <div className='verifyLinkbtn'>
                <Check size={20} color="#FCD535" cursor="not-allowed" className='verifyLinkbtn mb-2' />
            </div>;
        } else {
            copy = (
                <button className='btn verifyLinkbtn' onClick={() => copyuserAddress(userProfile?.refferCode)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 9.667C7 8.95967 7.28099 8.28131 7.78115 7.78115C8.28131 7.28099 8.95967 7 9.667 7H18.333C18.6832 7 19.03 7.06898 19.3536 7.20301C19.6772 7.33704 19.9712 7.53349 20.2189 7.78115C20.4665 8.0288 20.663 8.32281 20.797 8.64638C20.931 8.96996 21 9.31676 21 9.667V18.333C21 18.6832 20.931 19.03 20.797 19.3536C20.663 19.6772 20.4665 19.9712 20.2189 20.2189C19.9712 20.4665 19.6772 20.663 19.3536 20.797C19.03 20.931 18.6832 21 18.333 21H9.667C9.31676 21 8.96996 20.931 8.64638 20.797C8.32281 20.663 8.0288 20.4665 7.78115 20.2189C7.53349 19.9712 7.33704 19.6772 7.20301 19.3536C7.06898 19.03 7 18.6832 7 18.333V9.667Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M4.012 16.737C3.70534 16.5622 3.45027 16.3095 3.27258 16.0045C3.09488 15.6995 3.00085 15.353 3 15V5C3 3.9 3.9 3 5 3H15C15.75 3 16.158 3.385 16.5 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            );
        }
    }

    const copyuserAddress = async data => {
        setUniqueId(data)
        await copyToClipboard(`https://thepillcoin.com/${data}`)
        toast.success("Referral Link is copied")
        setTimeout(() => {
            setUniqueId(false)
        }, 300);
    }
    let userIDCopy;
    if (userProfile?.userId) {
        if (uniqueId === userProfile?.userId) {
            userIDCopy = <Check size={20} color="#FCD535" cursor="not-allowed" />
        } else {
            userIDCopy = (
                <span>

                    <button className='btn btnEmpty' onClick={() => copyUserId(userProfile?.userId)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 9.667C7 8.95967 7.28099 8.28131 7.78115 7.78115C8.28131 7.28099 8.95967 7 9.667 7H18.333C18.6832 7 19.03 7.06898 19.3536 7.20301C19.6772 7.33704 19.9712 7.53349 20.2189 7.78115C20.4665 8.0288 20.663 8.32281 20.797 8.64638C20.931 8.96996 21 9.31676 21 9.667V18.333C21 18.6832 20.931 19.03 20.797 19.3536C20.663 19.6772 20.4665 19.9712 20.2189 20.2189C19.9712 20.4665 19.6772 20.663 19.3536 20.797C19.03 20.931 18.6832 21 18.333 21H9.667C9.31676 21 8.96996 20.931 8.64638 20.797C8.32281 20.663 8.0288 20.4665 7.78115 20.2189C7.53349 19.9712 7.33704 19.6772 7.20301 19.3536C7.06898 19.03 7 18.6832 7 18.333V9.667Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.012 16.737C3.70534 16.5622 3.45027 16.3095 3.27258 16.0045C3.09488 15.6995 3.00085 15.353 3 15V5C3 3.9 3.9 3 5 3H15C15.75 3 16.158 3.385 16.5 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </span>

            )
        }
    }
    const copyUserId = async data => {
        setUniqueId(data)
        await copyToClipboard(data)
        toast.success("ID is copied")
        setTimeout(() => {
            setUniqueId(false)
        }, 300);
    }

    return (
        <>
            {(isLoading || isloadingconnect) && <Loader />}

            <div className="mainContent mainVH-100">
                <div className="homebanner profileDetailsBanner">
                    <div className="container position-relative">
                        <div className='row justify-content-center'>
                            <div className="col-lg-6">
                                <div className="bannerContent mt-4">
                                    <h2>New Digital Feature </h2>
                                    <h1 className='profileTitle'>
                                        Welcome to <span className="text-primary">THE PILL</span>
                                    </h1>
                                </div>
                                <div className="shadowcoin mt-n5">
                                    <div className="coinGifImg">
                                        <img src={require('../../assets/images/profile-deails-coin.gif')} alt='profile-deails-coin.gif' className='img-fluid' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="profileCard">
                                    <div className="titleHead d-flex justify-content-between">
                                        Profile Details


                                        <div className='dashboardLabelbx mb-2'>ID <span className='fw-600 text-white'>{userProfile?.userId}

                                            {userIDCopy}
                                        </span></div>

                                    </div>
                                    <form onSubmit={handleSubmit(onSubmit)}>

                                        <div className="row">
                                            <div className="col-md order-2 order-md-1">
                                                <div className="form-group formInputs">
                                                    <label className='' htmlFor='name'>Username</label>
                                                    <Controller
                                                        name="username"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <input
                                                                {...field}
                                                                type="text"
                                                                className="form-control"
                                                                onKeyPress={checkRefChar}
                                                                id="regId1"
                                                                placeholder="Enter Your Name"


                                                            />
                                                        )}
                                                    />
                                                    {errors.username && <p className="errMsg">* {errors.username.message}</p>}
                                                </div>


                                                <div className="form-group formInputs">
                                                    <label className='' htmlFor='country'>Country</label>
                                                    <div className='formDropdown'>
                                                        <ReactFlagsSelect
                                                            selected={selected}
                                                            searchable
                                                            onSelect={(code) => {

                                                                const country = CountryFile.find(o => o.code === code);

                                                                setCountryName(country?.name)
                                                                setCountryCode(country)
                                                                setSelected(code)
                                                            }
                                                            }
                                                            className='form-control flagcountrySelect'
                                                            countries={['AS', 'AI', 'BM', 'VI', 'JE', 'TK', 'CK', 'GI', 'KY', 'AL', 'AD']}
                                                            blacklistCountries={true}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="form-group formInputs">
                                                    <label className='' htmlFor='mobile'>Phone Number</label>


                                                    <div className="row form-row">
                                                        <div className="col-3 col-md-auto" >
                                                            <input className='form-control' type='text' placeholder='' value={dialCode} style={{ maxWidth: '80px' }} />


                                                        </div>
                                                        <div className="col-9 col-md">

                                                            <Controller
                                                                name="mobile"
                                                                control={control}
                                                                render={({ field }) => (
                                                                    <input
                                                                        {...field}
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Your phone Number"
                                                                        autoComplete="off"
                                                                        onInput={(e) => {
                                                                            e.target.value = e.target.value.replace(/\D/g, '');
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {errors.mobile && <p className="errMsg">* {errors.mobile.message}</p>}
                                                        </div>
                                                    </div>


                                                </div>
                                                <div className="form-group formInputs">
                                                    <label htmlFor="pincode">Pincode</label>
                                                    <Controller
                                                        name="pincode"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <input
                                                                {...field}
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter Pincode"

                                                            />
                                                        )}
                                                    />
                                                    {errors.pincode && <p className="errMsg">* {errors.pincode.message}</p>}
                                                </div>
                                                <div className="form-group formInputs">
                                                    <label className='' htmlFor='email'>Email Address</label>
                                                    <div className={`${verifiedMail || userProfile?.username ? 'verifysec' : ''}`}>
                                                        <Controller
                                                            name="email"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <input
                                                                    {...field}
                                                                    type="text"
                                                                    className="form-control"
                                                                    disabled={userProfile?.isEmailVerified || waitingTime}
                                                                    id="regId1"
                                                                    placeholder="Enter Your Email Address"
                                                                    autoComplete="off"


                                                                />
                                                            )}
                                                        />
                                                        <div className='verifyPos'>
                                                            {content}

                                                        </div>
                                                    </div>



                                                    {errors.email && <p className="errMsg">* {errors.email.message}</p>}

                                                </div>
                                                <div className="form-group formInputs">
                                                    <label className='' htmlFor='referral'>Referral Link</label>
                                                    <div className={`${userProfile?.refferCode ? 'verifysec' : ''}`}>

                                                        <Controller
                                                            name="referral"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <input
                                                                    {...field}
                                                                    type="text"
                                                                    className="form-control"
                                                                    disabled={userProfile?.refferCode}
                                                                    value={`https://thepillcoin.com/${userProfile?.refferCode}`}
                                                                    id="regId1"
                                                                    autoComplete="off"


                                                                />
                                                            )}
                                                        />
                                                        <div className='verifyPos'>

                                                            {copy}

                                                        </div>
                                                    </div>
                                                </div>
                                                {enableOTP && waitingTime ?

                                                    <div className="form-group formInputs">
                                                        <label className='' htmlFor='otp'>Enter your OTP</label>
                                                        <input type="tel"
                                                            className="form-control"
                                                            maxLength={6}
                                                            value={mailOTP}
                                                            onChange={handleChange}
                                                            onInput={handleKeyDown}
                                                            placeholder="Enter your OTP"
                                                        />

                                                        {errors.otp && <p className="errMsg">* {errors.otp.message}</p>}

                                                    </div>
                                                    : ""}
                                                <div className='mt-4 mb-3'>
                                                    {enableOTP ?
                                                        <button type='button' className='btn btn-primary' onClick={(e) => verifyMailOTP(e)} >Verify</button>
                                                        :
                                                        <button type='submit' className='btn btn-primary' disabled={(!isDirty || !isValid) && (!checkCover)} >Submit</button>
                                                    }                                                </div>
                                            </div>
                                            <div className="col-md-auto order-1 order-md-2">
                                                <div className='userImgUpload'>

                                                    <label className="userImgBorder" htmlFor='fileUserImg'>
                                                        {selfie ?
                                                            <img src={selfie} alt='userImg' className='img-fluid' />
                                                            :
                                                            <img src={userprofileImage} alt='userImg' className='img-fluid' />
                                                        }

                                                    </label>

                                                    <label className='uploadfile' htmlFor='fileUserImg'>
                                                        <input
                                                            type="file"
                                                            id='fileUserImg'
                                                            className='fileInput'
                                                            name="profileImage"
                                                            accept=".png,.jpg,.jpeg"
                                                            onChange={async (e) => {
                                                                try {
                                                                    let img = e.target.files[0]
                                                                    const reader = new FileReader();
                                                                    clearErrors("profileImage")
                                                                    setValue("profileImage", null)
                                                                    setSelfie(null)
                                                                    reader.onload = (event) => {
                                                                        const bytes = new Uint8Array(event.target.result);
                                                                        if ((bytes[0] === 0x89 && bytes[1] === 0x50) || (bytes[0] === 0xFF && bytes[1] === 0xD8)) {
                                                                            SelfieImg(e)
                                                                        } else {
                                                                            toast.error('Please select image file')
                                                                        }
                                                                    };

                                                                    reader.onerror = (error) => {

                                                                    };
                                                                    reader.readAsArrayBuffer(img);
                                                                } catch (e) { }
                                                            }}
                                                        />
                                                        <img src={require('../../assets/images/frameImgupload.png')} alt='frameupload' />
                                                    </label>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='footerbottom mt-n5'>
                    Copyright © {getyear} the pill  – All Rights Reserved.
                </div>
            </div>

        </>


    )
}

export default ProfileDetails